import React, { useEffect, useState } from "react";
import { NavLink as Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
//action
import "react-phone-number-input/style.css";
import { parsePhoneNumber } from "libphonenumber-js";
import PhoneInputWithCountrySelect, {
  isValidPhoneNumber,
} from "react-phone-number-input";
import { css } from "@emotion/css";
import { Button, Col, Form, Row, Input, Divider, Tooltip } from "antd";
import TimesheetIcon from "../../../Icons/TimesheetIcon";
import AdminSignupRCol from "./adminSignupRCol";
import { adminRegisterAction } from "../../../store/action/admin/authActions";
import SignupCarousel from "./SignupCarousel";

import BackButtonCircleIcon from "../../../Icons/BackButtonCircleIcon";
import EmailIcon from "../../../Icons/EmailIcon";
import UserIcon from "../../../Icons/UserIcon";
import { testimonials } from "./Components/OnboardingData";
import LogoMarquee from "./LogoMarquee";
import ContactUsPopup from "../../Pages/ContactUsPopup";
import CustomLoaderIcon from "../../../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";

function AdminSignupForm() {
  // eslint-disable-next-line no-unused-vars
  const [promoConfirm, setPromoConfirm] = useState(false);
  const router = useNavigate();

  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const resendOtpBySmsList = useSelector((state) => state.resendOtpBySmsList);
  const { resendOtpBySmsLoading, resendOtpBySmsError } = resendOtpBySmsList;
  const [data, setData] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");

  const handlePhoneChange = (value) => {
    setPhoneNumber(value);
  };
  const onFinish = async (values) => {
    const promo = values?.promoCode?.toLowerCase();
    // eslint-disable-next-line no-unused-vars
    const nameRegex = /^[A-Za-z]+(?:s[A-Za-z]+)?$/;
    if (
      promo === "supercharge" ||
      promo === "sbp" ||
      promo === "pakstartup" ||
      promo === "poil" ||
      promo === "mnj" ||
      promo === "ps" ||
      promo === "startuppakistan" ||
      promo === "vision2022" ||
      promo === undefined ||
      promo === ""
    ) {
      if (
        promo === "supercharge" ||
        promo === "sbp" ||
        promo === "pakstartup" ||
        promo === "poil" ||
        promo === "ps" ||
        promo === "startuppakistan" ||
        promo === "vision2022" ||
        promo === "mnj"
      ) {
        localStorage.setItem("promo", JSON.stringify(promo));
      }
      if (!isValidPhoneNumber(phoneNumber)) {
        setPromoConfirm("Invalid phone number!");
        // message.error("Invalid phone number!");
        return;
      }
      const parsedNumber = parsePhoneNumber(phoneNumber);
      try {
        const { firstName, lastName, email, password } = values;

        const emails = email.toLowerCase();
        if (nameRegex.test(firstName) || nameRegex.test(lastName)) {
          // setEmailVrfyModal(true);
          // router(`/admin/emailVerify?email=${emails}`);

          if (promo) {
            router("/admin/promo/congrates");
          } else {
            let data = {
              firstName: firstName,
              lastName: lastName,
              countryCode: parsedNumber.countryCallingCode,
              number: parsedNumber.nationalNumber,
              email: emails,
              password: password,
              cnic: "42101-0000000-0",
              city: "karachi",
              province: "sindh",
              country: "pakistan",
              address: "dummy_address",
            };
            setData(data);
            sessionStorage.setItem("phoneNo", data.number);
            sessionStorage.setItem("email", data.email);
            sessionStorage.setItem("countryCode", data.countryCode);
            await dispatch(adminRegisterAction(data));
            const promo = JSON.parse(localStorage.getItem("promo"));
            // setEmailVrfyModal(true);
            // router(`/admin/emailVerify?email=${emails}`);
            // if (promo) {
            //   router("/admin/promo/congrates");
            // } else {
            // const data1 = {
            //   countryCode: parsedNumber.countryCallingCode,
            //   phoneNo: parsedNumber.nationalNumber,
            // };
            // await dispatch(authActions_admin.resendOtpBySMSAction(data1));

            router("/sign-up-via-phone-otp", {
              replace: true,
            });
            // window.location.href =
            //   "/admin/onboarding-wizard/organization-detail";
            // }
            form.resetFields();
          }
        } else {
          setPromoConfirm("Please enter valid first name and last name!");
        }
      } catch (error) {
        // setPromoConfirm("Network error");
        // message.error("Please try again later");
      }
    } else {
      setPromoConfirm("Promo Code does'nt exist!");
    }
  };

  const adminRegister = useSelector((state) => state.adminRegister);
  const { loading, error } = adminRegister;

  //check if user has already logged in
  useEffect(() => {
    if (
      sharedUserInfo &&
      sharedUserInfo?.payload?.email &&
      sharedUserInfo?.payload?.type === "user"
    ) {
      router("/user/dashboard", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sharedUserInfo]);

  const rightColstyle = {
    border: "none",
    // minHeight: "60vh",
    borderRadius: "32px",
    // padding: "0px 10px",
  };
  const headDynamic = css`
    @media (max-width: 768px) {
      font-size: 12px;
    }
    @media (min-width: 769px) {
      font-size: 14px;
    }
    @media (min-width: 1391px) {
      font-size: 16px;
    }
  `;
  const paraDynamic = css`
    @media (min-width: 768px) {
      font-size: 13px;
    }
    @media (min-width: 1200px) {
      font-size: 9px;
    }
    @media (min-width: 1260px) {
      font-size: 10px;
    }
    @media (min-width: 1380px) {
      font-size: 11px;
    }
    @media (min-width: 1510px) {
      font-size: 12px;
    }
    @media (min-width: 1630px) {
      font-size: 13px;
    }
  `;
  return (
    <div
      style={{
        border: "none",
        borderRadius: "32px",
        backgroundColor: "white",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Row
        className={css`
          flex-direction: row;

          justify-content: center;
          @media (max-width: 1200px) {
            flex-direction: column;
          }
        `}
        style={{
          display: "flex",
          justifyContent: "center",
          // alignItems: "center",
          minHeight: "90vh",
        }}
      >
        <Col span={24} style={{ paddingTop: "20px", paddingLeft: "40px" }}>
          <Row
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Col style={{ marginRight: "8px" }}>
              <TimesheetIcon color="#F4765A" width="35" />
            </Col>
            <Col>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ color: "#F4765A", fontSize: "smaller" }}>
                  Onboarding time
                </p>
                <span style={{ marginTop: "-5px" }}>10 - 15 minutes</span>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              //   margin: "50px 0",
            }}
          >
            <Col
              span={12}
              xs={22}
              sm={22}
              md={22}
              lg={22}
              xl={12}
              xxl={12}
              style={{ marginRight: "20px " }}
              className={css`
                opacity: 0;
                animation: fadeIn 1s forwards;
                @keyframes fadeIn {
                  from {
                    opacity: 0;
                    transform: translateY(-20px);
                  }
                  to {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
              `}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  marginBottom: "10px",
                }}
              >
                {/* <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              {" "}
            </div> */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {" "}
                    <Tooltip title="Login">
                      <Link style={{ marginBottom: "-3px" }} to="/login">
                        <BackButtonCircleIcon
                          className={css`
                            transition: 0.3s ease-in-out;
                            &:hover {
                              color: #f16747;
                            }
                          `}
                          style={{
                            fontSize: "clamp(20px, 2.5vw,25px)",
                            fontWeight: "bold",
                          }}
                        />
                      </Link>
                    </Tooltip>
                    <p
                      style={{
                        fontSize: "clamp(20px, 2.5vw,25px)",
                        fontWeight: "bold",
                      }}
                    >
                      Get started with Meet Max
                    </p>
                  </div>
                </div>
                <p
                  style={{
                    textAlign: "left",
                    fontSize: "clamp(12px, 2.5vw,16px)",
                  }}
                >
                  <strong style={{ color: "#f3795d" }}>100% </strong>
                  free. No credit card needed!
                </p>
              </div>
              <Divider
                style={{
                  margin: "0px",
                  marginBottom: "10px",
                  marginTop: "5px",
                }}
              />
              <div
                style={{
                  marginTop: "15px",
                }}
                className={css`
                  .ant-input-outlined {
                    height: clamp(38px, 3vw, 48px) !important;
                    font-family: "Inter", sans-serif !important;
                    font-size: clamp(12px, 0.8vw, 14px) !important;
                  }
                  .PhoneInputInput {
                    height: clamp(38px, 3vw, 48px) !important;
                    border-radius: 20px;
                  }
                `}
              >
                <Form
                  form={form}
                  name="normal_login"
                  className="login-form"
                  layout="vertical"
                  autoComplete="on"
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                >
                  <Row gutter={12}>
                    <Col span={12}>
                      <Form.Item
                        name="firstName"
                        // label="First Name*"
                        rules={[
                          {
                            required: true,
                            message: "Enter your first name",
                          },
                        ]}
                      >
                        <Input
                          style={{
                            height: "48px",
                            textTransform: "capitalize",
                          }}
                          prefix={
                            <UserIcon
                              style={{
                                margin: "0px 5px",
                                marginLeft: "7px",
                                color: "#d6d6d6",
                              }}
                            />
                          }
                          placeholder="First Name"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="lastName"
                        // label="Last Name*"
                        rules={[
                          {
                            required: true,
                            message: "Enter your last name",
                          },
                        ]}
                      >
                        <Input
                          style={{
                            height: "48px",
                            textTransform: "capitalize",
                          }}
                          prefix={
                            <UserIcon
                              style={{
                                margin: "0px 5px",
                                marginLeft: "7px",
                                color: "#d6d6d6",
                              }}
                            />
                          }
                          placeholder="Last Name"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    name="email"
                    // label="Email*"
                    rules={[
                      {
                        type: "email",
                        required: true,
                        message: "Enter your Work Email",
                      },
                    ]}
                  >
                    <Input
                      style={{ height: "48px" }}
                      prefix={
                        <EmailIcon
                          style={{
                            margin: "0px 5px",
                            marginLeft: "7px",
                            color: "#d6d6d6",
                          }}
                        />
                      }
                      placeholder="Work Email"
                      // style={{ textTransform: "lowercase" }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="phone"
                    // label="Phone*"
                    rules={[
                      {
                        required: true,
                        message: "Enter your Mobile Number",
                      },
                    ]}
                  >
                    <PhoneInputWithCountrySelect
                      className={css`
                        .PhoneInputInput {
                          border: 1px solid rgb(0 0 0 / 8%) !important;
                        }
                      `}
                      placeholder="Mobile Number"
                      onChange={handlePhoneChange}
                      international
                      defaultCountry="AE" // Set the default country to USA
                    />
                  </Form.Item>

                  <Col span={12}>
                    {resendOtpBySmsError && (
                      <p style={{ color: "red" }}>{resendOtpBySmsError}</p>
                    )}
                  </Col>
                  {error && (
                    <div
                      id="error"
                      style={{ color: "red", marginBottom: "10px" }}
                    >
                      {error}
                    </div>
                  )}
                  {promoConfirm && (
                    <div
                      id="error"
                      style={{ color: "red", marginBottom: "10px" }}
                    >
                      {promoConfirm}
                    </div>
                  )}
                  {/* <p
                className="spacer-medium"
                // style={{ fontSize: 14, fontWeight: 600 }}
              >
                Already have an account?{" "}
                <Link to="/login">
                  {" "}
                  <span style={{ color: "#f47e63" }}>Click here to login</span>
                </Link>
              </p> */}
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType={
                        loading || resendOtpBySmsLoading ? "button" : "submit"
                      }
                      style={{ width: "100%" }}
                      loading={loading || resendOtpBySmsLoading}
                    >
                      Get started for Free
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Form.Item name="remember" valuePropName="checked" noStyle>
                      <p
                        className={paraDynamic}
                        style={{
                          textAlign: "left",
                          // fontSize: "13px",
                          color: "gray",
                        }}
                      >
                        By clicking you acknowledge that you have read and
                        understood, and agree to Meet Max's
                        <a
                          href="https://maxhr.io/terms-of-service/"
                          target="_blank"
                          style={{
                            fontWeight: 600,
                            color: "#f47e63",
                            marginLeft: "5px",
                          }}
                        >
                          terms &#38; conditions
                        </a>
                      </p>
                      {/* <Checkbox>I agree to </Checkbox> */}
                    </Form.Item>
                  </Form.Item>
                </Form>
              </div>
            </Col>
            <Col
              span={10}
              xs={20}
              sm={20}
              md={20}
              lg={20}
              xl={10}
              xxl={10}
              style={{ display: "block", marginBottom: "20px" }}
            >
              <AdminSignupRCol styled={rightColstyle}>
                <Row>
                  <Col
                    span={24}
                    style={{
                      marginTop: "20px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    <p className={headDynamic}>
                      Join now and save <strong>100+ man-hours </strong>
                      every month with our efficient HRMS!
                    </p>
                  </Col>
                  <Col span={24} style={{ marginBottom: "10px " }}>
                    <LogoMarquee />
                  </Col>
                  {/* Carousel */}
                  <Col
                    span={24}
                    style={{
                      borderTop: "1px solid #ccc",
                      // borderBottom: "1px solid #ccc",
                      padding: "10px 0",
                    }}
                  >
                    <SignupCarousel data={testimonials} />
                  </Col>
                </Row>
              </AdminSignupRCol>
            </Col>
          </Row>
        </Col>
      </Row>

      <ContactUsPopup />
    </div>
  );
}

export default AdminSignupForm;
